// Mock data for Cleven Cleaning website

export const companyInfo = {
  name: "Cleven Cleaning",
  tagline: "Fresh windows",
  phone: "06 - 83 65 35 11",
  phoneClean: "0683653511",
  email: "info@clevencleaning.nl",
  kvk: "75029979",
  location: "Rosmalen en omstreken",
  rating: 4.8,
  reviewCount: 49,
};

export const services = [
  {
    id: 1,
    title: "Glasbewassing",
    slug: "glasbewassing",
    description: "Professionele glazenwasser service voor kristalheldere ramen.",
    icon: "Sparkles",
    category: "schoonmaak",
  },
  {
    id: 2,
    title: "Zonnepaneel reiniging",
    slug: "zonnepanelen-reinigen",
    description: "Verhoog het rendement van uw zonnepanelen met onze specialistische reiniging.",
    icon: "Sun",
    category: "schoonmaak",
  },
  {
    id: 3,
    title: "Kozijn reiniging",
    slug: "kozijnen-reinigen",
    description: "Grondige reiniging van al uw kozijnen voor een frisse uitstraling.",
    icon: "Frame",
    category: "schoonmaak",
  },
  {
    id: 4,
    title: "Houtwerk reiniging",
    slug: "houtwerk-reinigen",
    description: "Vakkundige reiniging van houten oppervlakken en gevelbekleding.",
    icon: "TreeDeciduous",
    category: "schoonmaak",
  },
  {
    id: 5,
    title: "Dakgoten leeghalen",
    slug: "dakgoten-leeghalen",
    description: "Voorkom waterschade met regelmatig onderhoud van uw dakgoten.",
    icon: "Droplets",
    category: "schoonmaak",
  },
  {
    id: 6,
    title: "Dak reinigen",
    slug: "dak-reinigen",
    description: "Verwijder mos, algen en vuil van uw dak voor een langere levensduur en mooiere uitstraling.",
    icon: "Home",
    category: "schoonmaak",
  },
];

export const hogedrukServices = [
  {
    id: 1,
    title: "Terras reinigen",
    slug: "terras-reinigen",
    description: "Geef uw terras een grondige opknapbeurt met onze professionele hogedrukreiniging.",
    icon: "LayoutGrid",
  },
  {
    id: 2,
    title: "Oprit reinigen",
    slug: "oprit-reinigen",
    description: "Verwijder hardnekkig vuil, mos en vlekken van uw oprit voor een verzorgde uitstraling.",
    icon: "Car",
  },
  {
    id: 3,
    title: "Gevel reinigen",
    slug: "gevelreiniging",
    description: "Breng uw gevel weer in topconditie met onze specialistische hogedrukreiniging.",
    icon: "Building2",
  },
  {
    id: 4,
    title: "Schutting reinigen",
    slug: "schutting-reinigen",
    description: "Verwijder groene aanslag en vuil van uw schutting voor een frisse look.",
    icon: "Fence",
  },
];

export const features = [
  {
    id: 1,
    title: "Goed contact",
    description: "Het tijdperk waar de glazenwasser zomaar op de stoep staat of over de poort heen klimt is voorbij. Dankzij ons CRM-systeem brengen wij u minimaal 24 uur van tevoren op de hoogte voordat wij bij u langskomen. Hierdoor komt u niet voor verrassingen te staan.",
    icon: "MessageCircle",
  },
  {
    id: 2,
    title: "Klanttevredenheid",
    description: "Bij Cleven Cleaning streven wij naar 100% klanttevredenheid. Het schoonmaak werk blijft mensen werk en kan er wel eens iets fout gaan. Mocht u niet tevreden zijn geef ons een seintje en wij komen zo snel mogelijk bij u terug om het op te lossen.",
    icon: "Heart",
  },
  {
    id: 3,
    title: "Betrouwbaar & Vakkundig",
    description: "Met jarenlange ervaring en professionele apparatuur leveren wij altijd kwaliteit. Onze medewerkers zijn getraind en verzekerd voor uw gemoedsrust.",
    icon: "ShieldCheck",
  },
];

export const footerLinks = [
  { label: "Algemene voorwaarden", to: "/algemene-voorwaarden" },
  { label: "Privacy beleid", to: "/privacybeleid" },
  { label: "Cookie verklaring", to: "/cookieverklaring" },
];

export const serviceAreas = [
  "Rosmalen",
  "'s-Hertogenbosch",
  "Den Bosch",
  "Vught",
  "Berlicum",
  "Heesch",
  "Nuland",
  "Uden",
  "Empel",
  "Hintham",
];

// Echte Google reviews — Cleven Cleaning Rosmalen (geverifieerd, Feb 2026)
export const testimonials = [
  {
    id: 1,
    author: "Nadia D.",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Heel vriendelijk, aankondiging netjes op tijd, goede service (vb verzoek om veranda ook mee te nemen) geen probleem! We zijn heel erg tevreden!",
  },
  {
    id: 2,
    author: "Judith van der Sluijs",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Cleven Cleaning doet periodiek bij ons de glasbewassing. We zijn heel tevreden. Werken netjes, komen afspraken na en zijn vriendelijk en flexibel.",
  },
  {
    id: 3,
    author: "Grace Grigoriou",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Al sinds we hier wonen een trouwe en zeer tevreden klant! Fijn dat je van te voren een mailtje krijgt over wanneer ze langskomen, altijd vrolijk en goed humeur.",
  },
  {
    id: 4,
    author: "Marya Hubers",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Altijd volgens afspraak op de afgesproken dag aanwezig. En een mailtje 2 dagen voordat ze komen om de ramen te lappen ook heel fijn.",
  },
  {
    id: 5,
    author: "Ben van der Heijden",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Zeer prettig bedrijf. Komen om de 8 weken alle ramen wassen. Plannen ze zelf in. Geven een paar dagen van te voren aan dat ze komen. Hoef er zelf niet achteraan.",
  },
  {
    id: 6,
    author: "Nancy van der Linde",
    source: "Google review",
    date: "1 jaar geleden",
    rating: 5,
    text: "Een paar keer per jaar komt Cleven Cleaning bij ons de ramen wassen. De afspraak wordt automatisch door gepland en een herinnering gestuurd.",
  },
];

export const faqs = [
  {
    id: 1,
    question: "Wat kost een glazenwasser in Rosmalen of Den Bosch?",
    answer:
      "De prijs hangt af van het aantal ramen, type pand en frequentie. Voor een gemiddeld rijtjeshuis start het tarief vanaf €35 per beurt (buitenzijde). Vul onze prijscalculator in voor een directe prijs op basis van uw situatie — vrijblijvend en zonder verplichtingen.",
  },
  {
    id: 2,
    question: "Hoe vaak moet ik mijn ramen laten wassen?",
    answer:
      "Voor de meeste woningen adviseren wij elke 6 tot 8 weken. Bij bedrijfspanden of bij veel aanslag (bijv. langs een drukke weg) kan maandelijks beter zijn. Klanten met een vast schema profiteren van een frequentiekorting en hoeven nooit zelf te onthouden dat het tijd is.",
  },
  {
    id: 3,
    question: "In welke plaatsen werken jullie?",
    answer:
      "Wij werken voor particulieren, VvE's en bedrijven in Rosmalen, 's-Hertogenbosch (Den Bosch), Vught, Berlicum, Heesch, Nuland, Uden, Empel en Hintham. Twijfelt u of uw adres binnen ons werkgebied valt? Vul uw postcode in bij de calculator — dan ziet u het direct.",
  },
  {
    id: 4,
    question: "Krijg ik vooraf bericht wanneer jullie komen?",
    answer:
      "Ja, altijd. Dankzij ons CRM-systeem ontvangt u minimaal 24 uur van tevoren bericht via WhatsApp of e-mail. Geen verrassingen meer dat de glazenwasser opeens op de stoep staat. U kunt eenvoudig herplannen als het niet uitkomt.",
  },
  {
    id: 5,
    question: "Werken jullie ook op hoogte / met een hoogwerker?",
    answer:
      "Voor de meeste woningen werken wij met een professionele wateronthardingsinstallatie en telescoopstelen tot 12 meter — geen ladders meer nodig. Voor grotere bedrijfspanden of bijzondere situaties huren wij desgewenst een hoogwerker in. Vraag een offerte aan voor uw specifieke situatie.",
  },
  {
    id: 6,
    question: "Zijn jullie verzekerd?",
    answer:
      "Ja, Cleven Cleaning is volledig verzekerd voor bedrijfsaansprakelijkheid en schade. Mocht er onverhoopt iets gebeuren tijdens de werkzaamheden, dan is alles netjes geregeld. Ons KvK-nummer is 75029979.",
  },
  {
    id: 7,
    question: "Hoe snel kan ik een afspraak inplannen?",
    answer:
      "Meestal kunnen wij binnen 1 tot 2 weken bij u langskomen. Voor spoedklussen (bijv. verstopte dakgoten vóór een regenbui) doen wij ons uiterste best om sneller in te plannen. Vul de calculator in of bel ons direct op 06-83653511.",
  },
  {
    id: 8,
    question: "Welke betaalmogelijkheden bieden jullie?",
    answer:
      "U kunt eenvoudig betalen via factuur (iDEAL/overschrijving) na afronding van de werkzaamheden. Particulieren krijgen 14 dagen betalingstermijn, voor zakelijke klanten en VvE's gelden de gebruikelijke termijnen op de factuur.",
  },
];
